import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useAdminAuth } from './AdminAuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, isLoading: userLoading } = useAuth();
  const { admin, isLoading: adminLoading } = useAdminAuth();

  if (userLoading || adminLoading) {
    return <div className="page-container"><p>Checking your account...</p></div>;
  }

  if (!user && !admin) {
    return <Navigate to="/" />;
  }

  if (adminOnly && !admin) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
